import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '@morningstar/shared/environment';

if (environment.production) {
  enableProdMode();

  const script = document.createElement('script');
  script.src = 'https://plausible.geekportal.app/js/script.js';
  script.async = true;
  script.defer = true;
  script.setAttribute('data-domain', 'app.workspacegeek.com');
  document.head.appendChild(script);
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.log(err));
